import { GuestProfile, MatchConfidence } from '@mews-commander/guest-profile';
import { Grid } from '@optimus-web/core';
import { ConfidenceChart } from './confidenceChart';
import { GuestInfo } from './guestInfo';

export interface GuestsInfoSectionProps {
    setSelectedGuestId: (id: string) => void;
    matchingProfiles: Array<GuestProfile>;
    confidenceLevel: MatchConfidence;
}

export const GuestsInfoSection = ({
    matchingProfiles,
    confidenceLevel,
    setSelectedGuestId,
}: GuestsInfoSectionProps) => {
    const [leftGuestData, rightGuestData] = matchingProfiles;

    return (
        <Grid
            templateColumns="25% 1fr 25%"
            columnGap="600"
            rowGap="400"
            alignItems="center"
            largePhoneMax={{ templateColumns: '1fr' }}
            tabletMax={{ columnGap: '400' }}
        >
            <GuestInfo
                onClick={setSelectedGuestId}
                id={leftGuestData.id}
                fullName={leftGuestData.fullName}
                createdUtc={leftGuestData.createdUtc}
                updatedUtc={leftGuestData.updatedUtc}
                imageId={leftGuestData.imageId}
            />

            <ConfidenceChart confidence={confidenceLevel} />
            <GuestInfo
                onClick={setSelectedGuestId}
                id={rightGuestData.id}
                fullName={rightGuestData.fullName}
                createdUtc={rightGuestData.createdUtc}
                updatedUtc={rightGuestData.updatedUtc}
                imageId={rightGuestData.imageId}
            />
        </Grid>
    );
};
